// extracted by mini-css-extract-plugin
module.exports = {"progressColor":"#1c75bc","primaryColor":"#16556d"};